import { css } from 'styled-components';
import { DEFAULT_TEXT_COLOR } from '../theme/ColorConstants';
export const focusRing = css(["outline-offset:1px;outline:2px solid ", ";"], DEFAULT_TEXT_COLOR);